import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from './actions'

export const useCategories = () => {
    const {
        refresh,
        initialize,
        categories = [],
    } = useSelector((state) => state.category);

    const dispatch = useDispatch();

    const setRefreshCategories = useCallback(
        (payload) => dispatch(actions.setRefreshCategories(payload)),
        [dispatch]
    );

    const setCategories = useCallback(
        (payload) => dispatch(actions.setCategories(payload)),
        [dispatch]
    );

    return {
        refresh,
        initialize,
        categories,
        setRefreshCategories,
        setCategories
    };
} 